//@ts-check
import { Controller } from "@hotwired/stimulus";

/**
 * Optional licensing groups use radios without a default. Clicking the
 * currently-selected radio (or its label) clears the group; native radios
 * cannot otherwise be unchecked.
 *
 * We track the previously-selected radio in controller state because at click
 * time `radio.checked` is already `true` for both "already selected" and
 * "just got selected", so the DOM alone can't tell them apart.
 */
export default class extends Controller {
  connect() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    const radios = /** @type {NodeListOf<HTMLInputElement>} */ (
      this.element.querySelectorAll('input[type="radio"]')
    );

    /** @type {HTMLInputElement | null} */
    this.selectedRadio = Array.from(radios).find((r) => r.checked) || null;

    radios.forEach((radio) => {
      radio.addEventListener(
        "click",
        () => {
          console.log("Radio clicked:", radio);
          if (this.selectedRadio === radio) {
            console.log(
              "Radio clicked is the same as the selected radio, unchecking it"
            );
            radio.checked = false;
            this.selectedRadio = null;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            console.log(
              "Radio clicked is different from the selected radio, setting the selected radio to the clicked radio"
            );
            this.selectedRadio = radio;
          }
        },
        { signal }
      );
    });
  }

  disconnect() {
    this.abortController.abort();
  }
}
